(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["looks-we-love"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function closeAll(except) {
      document.querySelectorAll('.lwl__slide.is-open').forEach(function (slide) {
        if (slide === except) return;
        slide.classList.remove('is-open');
        var pop = slide.querySelector('.lwl__popup');
        var btn = slide.querySelector('.lwl__btn');
        if (pop) { pop.classList.remove('is-visible'); pop.hidden = true; }
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }

    function open(slide) {
      closeAll(slide);
      var pop = slide.querySelector('.lwl__popup');
      var btn = slide.querySelector('.lwl__btn');
      if (!pop) return;
      pop.hidden = false;
      slide.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { pop.classList.add('is-visible'); });
      });
      var first = pop.querySelector('a');
      if (first) first.focus({ preventScroll: true });
    }

    function updateNav(root) {
      var track = root.querySelector('.lwl__track');
      var prev = root.querySelector('.lwl__nav--prev');
      var next = root.querySelector('.lwl__nav--next');
      if (!track || !prev || !next) return;
      var max = track.scrollWidth - track.clientWidth;
      prev.hidden = max <= 4 || track.scrollLeft <= 4;
      next.hidden = max <= 4 || track.scrollLeft >= max - 4;
    }

    function initAll() {
      document.querySelectorAll('.lwl').forEach(function (root) {
        updateNav(root);
        var track = root.querySelector('.lwl__track');
        if (track && !track.dataset.lwlBound) {
          track.dataset.lwlBound = '1';
          track.addEventListener('scroll', function () { updateNav(root); }, { passive: true });
        }
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.lwl__btn');
      if (btn) {
        open(btn.closest('.lwl__slide'));
        return;
      }

      var closeBtn = e.target.closest('.lwl__close');
      if (closeBtn) {
        var openBtn = closeBtn.closest('.lwl__slide').querySelector('.lwl__btn');
        closeAll();
        if (openBtn) openBtn.focus({ preventScroll: true });
        return;
      }

      var nav = e.target.closest('.lwl__nav');
      if (nav) {
        var root = nav.closest('.lwl');
        var track = root.querySelector('.lwl__track');
        var slide = track.querySelector('.lwl__slide');
        var step = slide ? slide.offsetWidth + 16 : 300;
        track.scrollBy({ left: nav.classList.contains('lwl__nav--next') ? step : -step });
        return;
      }

      // Klick woanders (außer auf eine Produktkarte) schließt das Popup
      if (!e.target.closest('.lwl__item')) closeAll();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openSlide = document.querySelector('.lwl__slide.is-open');
      if (!openSlide) return;
      var btn = openSlide.querySelector('.lwl__btn');
      closeAll();
      if (btn) btn.focus({ preventScroll: true });
    });

    window.addEventListener('resize', initAll);
    window.addEventListener('load', initAll);
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:section:unload', function () { closeAll(); });
    initAll();
  })();

  } catch(e) { console.error(e); }
})();
})();
